import {
  CreatedBy,
  DeliveryStatus,
  ScheduleMode,
} from '../../../../../../views/marketing/push-notifications/Constants';

export default {
  title: 'Campagne',
  filters: {
    search: 'Cerca campagne...',
  },
  columns: {
    title: 'Titolo',
    created_by: 'Creato da',
    schedule_mode: 'Modalità pianificazione',
    scheduled_at: 'Pianificato il',
    sent_at: 'Inviato il',
    status: 'Stato',
    sent: 'Inviato',
    delivered: 'Consegnato',
    delivered_rate: 'Tasso di consegna',
    clicks: 'Clic',
    click_rate: 'Tasso di clic',
    live: 'Attivo',
    actions: 'Azioni',
  },
  active_status: {
    draft: 'Bozza',
    active: 'Attivo',
  },
  delivery: {
    in_progress: 'In attesa di conferma',
    awaiting: 'In attesa di conferma',
    verified: 'Verificato {{relative}}',
    next_check_around: 'Prossimo controllo intorno alle {{time}}',
  },
  breakdown: {
    delivered: '{{count}} consegnati',
    pending: '{{count}} in attesa di conferma',
    failed_title: 'Non consegnato',
    all_delivered: 'Consegnato a tutti i destinatari.',
    load_error: 'Impossibile caricare il riepilogo delle consegne.',
    reasons: {
      DeviceNotRegistered: 'App rimossa o notifiche disattivate (token scaduto)',
      MessageRateExceeded: 'Temporaneamente limitato da Expo',
      MessageTooBig: 'Payload della notifica troppo grande',
      MismatchSenderId: 'Credenziali push non corrispondenti',
      InvalidCredentials: 'Credenziali push non valide',
      batch_failed: 'Invio batch non riuscito',
      missing_ticket: 'Nessuna conferma ricevuta da Expo',
      unknown: 'Errore di consegna sconosciuto',
    },
  },
  created_by: {
    [CreatedBy.System]: 'Sistema',
    [CreatedBy.User]: 'Utente',
  },
  schedule_mode: {
    [ScheduleMode.Instant]: 'Immediato',
    [ScheduleMode.Scheduled]: 'Pianificato',
  },
  delivery_status: {
    [DeliveryStatus.Sending]: 'In invio',
    [DeliveryStatus.Sent]: 'Inviato',
    [DeliveryStatus.Queued]: 'In coda',
    [DeliveryStatus.Failed]: 'Non riuscito',
  },
  actions: {
    details: 'Dettagli',
    view_details: 'Visualizza dettagli',
    resend: 'Reinvia',
    duplicate_edit: 'Duplica e modifica',
    delete: 'Elimina',
    edit: 'Modifica',
    activate: 'Attiva',
    deactivate: 'Disattiva',
  },
  success_messages: {
    campaign_updated: 'Campagna aggiornata con successo',
    campaign_deleted: 'Campagna eliminata con successo',
  },
  error_messages: {
    failed_to_update_campaign: 'Aggiornamento della campagna non riuscito',
    failed_to_load_data: 'Caricamento dati non riuscito',
    failed_to_delete_campaign: 'Eliminazione della campagna non riuscita',
  },
};
